import { getCookie, setCookie } from './cookies';

const COOKIE_NAME = 'announcement_bar_closed';
const COOKIE_LIFETIME_DAYS = 90;

/**
 * Einzeilige Announcement-Bar im Header.
 *
 * Blendet die Bar aus, sobald sie geschlossen wird, und merkt sich das per Cookie.
 * Der data-announcement-key identifiziert die Meldung: wird er im Template
 * geaendert, wird die Bar erneut ausgespielt.
 *
 * @see templates/frontend/default_de/component_teaser_announcementbar.tpl
 */
export default function () {
  const $bar = $('.js-announcement-bar');

  if (!$bar.length) {
    return;
  }

  const announcementKey = String($bar.data('announcementKey') || '');

  if (announcementKey && getCookie(COOKIE_NAME) === announcementKey) {
    $bar.remove();
    return;
  }

  $bar.on('click', '.js-announcement-bar-close', function () {
    if (announcementKey) {
      setCookie(COOKIE_NAME, announcementKey, COOKIE_LIFETIME_DAYS, '/');
    }
    $bar.slideUp(200, function () {
      $bar.remove();
    });
  });
}
